/* Breed desktopmenu: rustig wisselen tussen panelen.

   Het thema fade bij het wisselen het oude paneel uit en het nieuwe in, allebei
   tegelijk. Halverwege zijn ze half doorzichtig en flitst de pagina erdoorheen.
   Komt de muis binnen 250ms van het ene paneel op het volgende, dan zetten we
   kort .mega-switching op de header: het paneel wisselt direct en alleen de
   inhoud fade zacht in (zie mega-menu.css). Daarnaast laden we de promofoto's
   pas zodra iemand het menu aanraakt (niet bij het laden van de pagina, en
   op mobiel nooit), zodat ze er al staan als een paneel opent. */
(function () {
  var nav = document.querySelector('.header__desktop');
  if (!nav || window.__megaMenu) return;
  window.__megaMenu = true;

  var wrapper = nav.closest('[data-header-wrapper]') || nav;
  var lastLeave = 0;
  var timer;

  nav.querySelectorAll('.menu__item.mega-panel').forEach(function (item) {
    item.addEventListener('mouseleave', function () {
      lastLeave = Date.now();
    });
    item.addEventListener('mouseenter', function () {
      if (Date.now() - lastLeave > 250) return;
      wrapper.classList.add('mega-switching');
      clearTimeout(timer);
      timer = setTimeout(function () {
        wrapper.classList.remove('mega-switching');
      }, 400);
    });
  });

  // Links in het paneel laten beginnen op dezelfde lijn als het eerste menu-item.
  var firstLabel = nav.querySelector('.menu__item .navlink--toplevel .navtext');
  function setIndent() {
    if (!firstLabel) return;
    var left = Math.round(firstLabel.getBoundingClientRect().left);
    if (left > 0) nav.style.setProperty('--mega-indent', left + 'px');
  }
  setIndent();
  window.addEventListener('resize', setIndent);
  window.addEventListener('load', setIndent);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setIndent);

  function preloadPromos() {
    nav.querySelectorAll('.mega-promo__image[data-mega-src]').forEach(function (img) {
      img.srcset = img.dataset.megaSrcset;
      img.src = img.dataset.megaSrc;
      img.removeAttribute('data-mega-src');
    });
  }
  nav.addEventListener('mouseenter', preloadPromos, {once: true});
  nav.addEventListener('focusin', preloadPromos, {once: true});
})();
